/* ============================================================================
   ROSEGOLD Paris — Page produit V2 (template product.rosegold-v2)
   Fichier NOUVEAU. JavaScript volontairement limité :
   - <rgv2-offer-picker> : sélection d'offre par ID de variante (jamais par titre),
     synchronisation de l'input caché du formulaire, du prix rendu en Liquid,
     du module cadeaux (paliers débloqués / verrouillés), du sticky et de l'URL
     (paramètres existants conservés, jamais au chargement).
   - <rgv2-gallery> : galerie scroll-snap sans librairie (miniatures horizontales,
     flèches, ordre des diapositives déduit du DOM) + lightbox d'agrandissement
     (les visuels fournis contiennent du texte : zoom plein écran non recadré).
   - Sticky add-to-cart : soumet LE formulaire principal (un seul chemin d'ajout,
     donc mêmes hooks Dawn / OCU / Subscribfy / dataLayer que le bouton principal).
   - Curseur avant/après ; lien « Lire les avis » → widget d'avis complet (bas de page).
   Aucune requête réseau n'est émise par ce fichier.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------ Offer picker */
  class RgOfferPicker extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-rgv2-main]') || document;
      const data = this.querySelector('script[type="application/json"]');
      try { this.variants = data ? JSON.parse(data.textContent) : []; } catch (e) { this.variants = []; }
      this.inputs = Array.from(this.querySelectorAll('input[name="rgv2-offer"]'));
      this.inputs.forEach((input) => {
        input.addEventListener('change', () => this.select(input.value, true));
      });
      const initial = this.inputs.find((i) => i.checked) || this.inputs.find((i) => !i.disabled);
      if (initial) this.select(initial.value, false);
      this.guardVariantInputs();
    }

    /* Révision 13/10 : des scripts tiers (Subscribfy « satc.js », constaté sur le
       live) réécrivent au chargement le champ caché « id » du formulaire et
       l'adresse (?variant=) avec la PREMIÈRE variante Shopify, en contradiction
       avec l'offre cochée (6 flacons par défaut). Le sélecteur reste la seule
       source de vérité : toute valeur étrangère est remise sur l'offre courante,
       et une adresse ?variant= étrangère est réalignée (sans en créer une). */
    guardVariantInputs() {
      const resync = () => {
        const v = this._current;
        if (!v) return;
        this.root.querySelectorAll('[data-rgv2-variant-input]').forEach((input) => {
          if (String(input.value) !== String(v.id)) {
            input.value = v.id;
            input.disabled = !v.available;
          }
        });
        try {
          const url = new URL(window.location.href);
          const param = url.searchParams.get('variant');
          if (param && String(param) !== String(v.id) && window.history && window.history.replaceState) {
            url.searchParams.set('variant', v.id);
            window.history.replaceState(window.history.state, '', url.toString());
          }
        } catch (e) { /* silencieux */ }
      };
      const inputs = Array.from(this.root.querySelectorAll('[data-rgv2-variant-input]'));
      if (!inputs.length) return;
      try {
        const mo = new MutationObserver(resync);
        inputs.forEach((input) => mo.observe(input, { attributes: true, attributeFilter: ['value'] }));
      } catch (e) { /* silencieux */ }
      /* Les écritures par propriété (input.value = …) ne déclenchent pas d'attribut :
         contrôle périodique court pendant la phase de chargement des apps. */
      let ticks = 0;
      const timer = window.setInterval(() => {
        resync();
        if (++ticks >= 40) window.clearInterval(timer);
      }, 250);
      document.addEventListener('DOMContentLoaded', resync);
      window.addEventListener('load', resync);
    }

    get current() { return this._current; }

    select(id, fromUser) {
      const variant = this.variants.find((v) => String(v.id) === String(id));
      if (!variant) return;
      this._current = variant;
      const root = this.root;

      // 1. Input caché de tous les formulaires de la section (principal + éventuels)
      root.querySelectorAll('[data-rgv2-variant-input]').forEach((input) => {
        input.value = variant.id;
        input.disabled = !variant.available;
      });

      // 2. Prix : blocs rendus en Liquid (un par variante), on affiche le bon
      root.querySelectorAll('[data-rgv2-price-for]').forEach((el) => {
        if (String(el.getAttribute('data-rgv2-price-for')) === String(variant.id)) el.setAttribute('data-active', '');
        else el.removeAttribute('data-active');
      });

      // 3. Boutons d'ajout : état épuisé + libellé
      root.querySelectorAll('[data-rgv2-submit]').forEach((btn) => {
        btn.disabled = !variant.available;
        const label = btn.querySelector('[data-rgv2-submit-label]');
        if (label) label.textContent = variant.available ? label.dataset.labelAdd : label.dataset.labelSoldout;
      });

      // 4. Sticky : prix rendus en Liquid (l'état du bouton suit le bouton principal, voir initSticky)
      root.querySelectorAll('[data-rgv2-sticky-for]').forEach((el) => {
        el.hidden = String(el.getAttribute('data-rgv2-sticky-for')) !== String(variant.id);
      });

      // 5. Galerie : image de variante si elle existe
      const gallery = root.querySelector('rgv2-gallery');
      if (gallery && variant.featured_media && variant.featured_media.id && typeof gallery.goToMedia === 'function') {
        gallery.goToMedia(variant.featured_media.id);
      }

      // 6. Module cadeaux : les cartes suivent UNIQUEMENT l'offre sélectionnée
      /* Révision 09/10 (consigne Kyrian) : aperçu de ce que l'offre choisie débloque,
         indépendamment du contenu actuel du panier (un panier déjà garni allumait
         tout, quelle que soit l'offre). L'état réel du panier reste affiché par le
         panier latéral ; le total du panier ne sert ici de base que s'il n'y a pas
         de sélecteur d'offre sur la page. */
      rgv2RenderGifts();

      // 7. URL : uniquement sur interaction utilisateur, en conservant les autres paramètres et l'ancre
      if (fromUser && this.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) { /* silencieux */ }
      }

      root.dispatchEvent(new CustomEvent('rgv2:variant-change', { detail: { variant: variant }, bubbles: true }));
    }
  }
  if (!customElements.get('rgv2-offer-picker')) customElements.define('rgv2-offer-picker', RgOfferPicker);

  /* ----------------------------------------------------------------- Gallery */
  class RgGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rgv2Init === 'true') return; // reconnexion (Theme Editor) : pas de double init
      this.dataset.rgv2Init = 'true';
      this.track = this.querySelector('[data-rgv2-track]');
      if (!this.track) return;
      // Ordre déduit du DOM : les diapositives et miniatures sont rendues dans le même ordre en Liquid
      this.slides = Array.from(this.querySelectorAll('[data-rgv2-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-rgv2-thumb]'));
      this.thumbs.forEach((t, k) => t.addEventListener('click', () => this.goTo(k)));
      const prev = this.querySelector('[data-rgv2-prev]');
      const next = this.querySelector('[data-rgv2-next]');
      if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.index + 1));
      this.track.addEventListener('scroll', () => {
        window.clearTimeout(this._timer);
        this._timer = window.setTimeout(() => this.sync(), 80);
      }, { passive: true });
      this.index = 0;
      this.sync();
      this.initLightbox();
    }
    disconnectedCallback() {
      // Theme Editor : la section rechargée recrée tout — on retire la lightbox
      // orpheline et son écouteur clavier pour éviter les doublons.
      if (this._lightbox) { this._lightbox.remove(); this._lightbox = null; }
      if (this._lbKeydown) { document.removeEventListener('keydown', this._lbKeydown); this._lbKeydown = null; }
      this.dataset.rgv2Init = 'false';
    }
    goTo(i) {
      if (!this.slides.length) return;
      const count = this.slides.length;
      const target = ((i % count) + count) % count; // boucle
      const slide = this.slides[target];
      this.ensureLoaded(target);
      const left = slide.offsetLeft - this.track.offsetLeft;
      if (Math.abs(target - this.index) > 1) {
        // Saut direct pour les miniatures éloignées : on neutralise le
        // scroll-behavior:smooth du CSS le temps du positionnement
        // (behavior:'auto' de scrollTo retomberait sur le smooth CSS).
        const prevBehavior = this.track.style.scrollBehavior;
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = left;
        this.track.style.scrollBehavior = prevBehavior;
        this.index = target;
        this.sync();
      } else {
        this.track.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    // Prépare l'image demandée et ses voisines (sans charger toute la galerie en pleine résolution)
    ensureLoaded(i) {
      [i - 1, i, i + 1].forEach((k) => {
        const s = this.slides[k];
        if (!s) return;
        s.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      });
    }
    goToMedia(mediaId) {
      const i = this.slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
      if (i >= 0) this.goTo(i);
    }
    sync() {
      if (!this.track.clientWidth) return;
      const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      this.index = Math.max(0, Math.min(i, this.slides.length - 1));
      this.thumbs.forEach((t, k) => t.setAttribute('aria-current', k === this.index ? 'true' : 'false'));
      this.ensureLoaded(this.index);
      // Met en pause les vidéos HTML5 qui sortent de l'écran
      this.slides.forEach((s, k) => { if (k !== this.index) s.querySelectorAll('video').forEach((v) => { try { v.pause(); } catch (e) {} }); });
    }

    /* Lightbox : agrandissement plein écran, image entière (object-fit: contain) */
    initLightbox() {
      const zoomables = this.slides.filter((s) => s.dataset.full);
      if (!zoomables.length) return;
      const box = document.createElement('div');
      box.className = 'rgv2 rgv2-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Agrandissement du visuel');
      box.innerHTML =
        '<img alt="">' +
        '<button type="button" class="rgv2-lightbox__close" aria-label="Fermer">&times;</button>' +
        (zoomables.length > 1
          ? '<button type="button" class="rgv2-lightbox__nav rgv2-lightbox__nav--prev" aria-label="Précédent"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
            '<button type="button" class="rgv2-lightbox__nav rgv2-lightbox__nav--next" aria-label="Suivant"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>'
          : '');
      document.body.appendChild(box);
      this._lightbox = box;
      const img = box.querySelector('img');
      const closeBtn = box.querySelector('.rgv2-lightbox__close');
      let zi = 0;
      const show = (k) => {
        zi = ((k % zoomables.length) + zoomables.length) % zoomables.length;
        const slide = zoomables[zi];
        img.src = slide.dataset.full;
        const inner = slide.querySelector('img');
        img.alt = inner ? inner.alt || '' : '';
      };
      const open = (k) => { show(k); box.setAttribute('data-open', 'true'); document.body.style.overflow = 'hidden'; this._lastFocus = document.activeElement; closeBtn.focus(); };
      const close = () => { box.removeAttribute('data-open'); document.body.style.overflow = ''; if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus(); };
      zoomables.forEach((s, k) => s.addEventListener('click', () => open(k)));
      closeBtn.addEventListener('click', close);
      box.addEventListener('click', (e) => { if (e.target === box) close(); });
      const prevBtn = box.querySelector('.rgv2-lightbox__nav--prev');
      const nextBtn = box.querySelector('.rgv2-lightbox__nav--next');
      if (prevBtn) prevBtn.addEventListener('click', () => show(zi - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => show(zi + 1));
      this._lbKeydown = (e) => {
        if (box.getAttribute('data-open') !== 'true') return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(zi - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(zi + 1); }
        if (e.key === 'Tab') {
          // Dialogue modal : le focus reste dans la lightbox
          const focusables = [closeBtn, prevBtn, nextBtn].filter(Boolean);
          const i = focusables.indexOf(document.activeElement);
          e.preventDefault();
          const next = e.shiftKey ? (i <= 0 ? focusables.length - 1 : i - 1) : (i >= focusables.length - 1 ? 0 : i + 1);
          focusables[next].focus();
        }
      };
      document.addEventListener('keydown', this._lbKeydown);
    }
  }
  if (!customElements.get('rgv2-gallery')) customElements.define('rgv2-gallery', RgGallery);

  /* ------------------------------------------------------------------ Sticky */
  function initSticky(root) {
    const bar = root.querySelector('[data-rgv2-sticky]');
    if (!bar || bar.dataset.rgv2Init === 'true') return;
    const mainBtn = root.querySelector('[data-rgv2-submit]');
    const form = mainBtn ? mainBtn.closest('form') : null;
    if (!mainBtn || !form) return;
    bar.dataset.rgv2Init = 'true';

    const stickyBtn = bar.querySelector('[data-rgv2-sticky-submit]');
    const stickyLabel = bar.querySelector('[data-rgv2-sticky-label]');
    const busy = () => mainBtn.getAttribute('aria-disabled') === 'true' || mainBtn.classList.contains('loading');

    // Nettoyage (section retirée ou rechargée dans l'éditeur) : observateurs, écouteurs et classes
    // du body, pour ne jamais laisser la barre XBoost masquée alors que la barre V2 n'existe plus.
    const listeners = new AbortController();
    const observers = [];
    let destroyed = false;
    let frame = 0;
    const destroy = () => {
      if (destroyed) return;
      destroyed = true;
      window.cancelAnimationFrame(frame);
      listeners.abort();
      observers.forEach((o) => o.disconnect());
      document.body.classList.remove('rgv2-sticky-active', 'rgv2-has-sticky');
      document.body.style.removeProperty('--rgv2-sticky-h');
      delete bar.dataset.rgv2Init;
    };
    document.addEventListener('shopify:section:unload', (e) => {
      if (e.target && e.target.contains(bar)) destroy();
    }, { signal: listeners.signal });

    // Le bouton sticky reflète l'état du bouton principal : épuisé, désactivé, en cours
    // d'ajout (Dawn pose aria-disabled + .loading) — évite les doubles ajouts.
    const syncButton = () => {
      if (!stickyBtn) return;
      stickyBtn.disabled = mainBtn.disabled;
      const isBusy = busy();
      stickyBtn.setAttribute('aria-disabled', isBusy ? 'true' : 'false');
      stickyBtn.classList.toggle('loading', isBusy);
      if (stickyLabel) {
        const txt = mainBtn.disabled ? stickyLabel.dataset.labelSoldout : stickyLabel.dataset.labelAdd;
        if (txt && stickyLabel.textContent.trim() !== txt) stickyLabel.textContent = txt;
      }
    };
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        if (mainBtn.disabled || busy()) return;
        // Même formulaire, même bouton : Dawn product-form, OCU, Subscribfy et le dataLayer voient un ajout identique
        if (typeof form.requestSubmit === 'function') form.requestSubmit(mainBtn); else mainBtn.click();
      }, { signal: listeners.signal });
      // Observation étroite : seuls les attributs d'état du bouton principal.
      try {
        const stateObserver = new MutationObserver(syncButton);
        stateObserver.observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
        observers.push(stateObserver);
      } catch (e) { /* silencieux */ }
      syncButton();
    }

    bar.hidden = false;
    // Hauteur réelle de la barre (safe-area comprise) : espace réservé en bas de page
    // pour ne jamais masquer le pied de page.
    const setHeight = () => {
      document.body.style.setProperty('--rgv2-sticky-h', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    };
    try {
      const sizeObserver = new ResizeObserver(setHeight);
      sizeObserver.observe(bar);
      observers.push(sizeObserver);
    } catch (e) { /* silencieux */ }

    // Affichage dès que le bouton principal est passé au-dessus de l'écran.
    // Calcul direct à chaque défilement (throttlé par requestAnimationFrame) :
    // fiable aussi lors des sauts d'ancre ou de la restauration de position,
    // que l'IntersectionObserver seul pouvait manquer.
    let ticking = false;
    const update = () => {
      ticking = false;
      if (destroyed) return;
      if (!bar.isConnected) { destroy(); return; }
      // Barre masquée par CSS (ex. « mobile uniquement » sur desktop) : non applicable à cette
      // largeur → pas de padding fantôme et la barre tierce (XBoost) n'est pas masquée.
      const applicable = window.getComputedStyle(bar).display !== 'none';
      const visible = applicable && mainBtn.getBoundingClientRect().bottom < 0;
      bar.setAttribute('data-visible', visible ? 'true' : 'false');
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bar.inert = !visible;
      if (visible) setHeight();
      document.body.classList.toggle('rgv2-sticky-active', applicable);
      document.body.classList.toggle('rgv2-has-sticky', visible);
    };
    const onScroll = () => { if (!ticking) { ticking = true; frame = window.requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true, signal: listeners.signal });
    window.addEventListener('resize', onScroll, { passive: true, signal: listeners.signal });
    update();
  }

  /* ------------------------------------------------------------ Before/after */
  function initBeforeAfter(scope) {
    scope.querySelectorAll('[data-rgv2-ba]').forEach((el) => {
      if (el.dataset.rgv2Init === 'true') return;
      const range = el.querySelector('input[type="range"]');
      if (!range) return;
      el.dataset.rgv2Init = 'true';
      const set = () => el.style.setProperty('--rgv2-ba-pos', range.value + '%');
      set();
      range.addEventListener('input', set);
    });
  }

  /* -------------------------------------------------------------------- Init */
  function reviewsTarget() {
    // 1) section « apps » du template V2 (clé rgv2_reviews, stable dans product.rosegold-v2.json)
    // 2) sinon le widget d'avis Okendo complet, en excluant la note du hero
    return (
      document.querySelector('.shopify-section[id$="__rgv2_reviews"]') ||
      Array.from(document.querySelectorAll('[data-oke-reviews-widget-holder], .okeReviews, [data-oke-widget]')).find((el) => !el.closest('[data-rgv2-main]')) ||
      null
    );
  }
  function initReviewLinks(scope) {
    scope.querySelectorAll('a[href="#rgv2-reviews"], [data-rgv2-reviews-link]').forEach((a) => {
      if (a.dataset.rgv2Init === 'true') return;
      a.dataset.rgv2Init = 'true';
      a.addEventListener('click', (e) => {
        const target = reviewsTarget();
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }
  /* Boutons « retour aux offres » (bloc final) : défilement doux vers le sélecteur */
  function initOfferLinks(scope) {
    scope.querySelectorAll('a[href="#rgv2-offers"]').forEach((a) => {
      if (a.dataset.rgv2Init === 'true') return;
      a.dataset.rgv2Init = 'true';
      a.addEventListener('click', (e) => {
        const target = document.getElementById('rgv2-offers');
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });
  }

  /* Bloc demande : compte à rebours vers une échéance FIXE (réglage de bloc).
     Jamais réinitialisé par visite ; bloc masqué une fois l'échéance passée. */
  /* Cartes cadeaux : état « débloqué » basé sur le total RÉEL du panier après remises
     (cart.total_price — même base que le moteur cadeaux du panier). État initial rendu
     en Liquid (data-cart-total) ; rafraîchi ici après chaque mouvement de panier. */
  function applyGiftsCartTotal(totalCents) {
    document.querySelectorAll('[data-rgv2-gifts]').forEach((box) => { box.dataset.cartTotal = String(totalCents); });
    rgv2RenderGifts();
  }
  function rgv2OfferTotal() {
    const picker = document.querySelector('rgv2-offer-picker');
    const v = picker && picker.current;
    return v && typeof v.price === 'number' ? v.price : null;
  }
  function rgv2RenderGifts() {
    const offerCents = rgv2OfferTotal();
    document.querySelectorAll('[data-rgv2-gifts]').forEach((box) => {
      const totalCents = offerCents === null ? (Number(box.dataset.cartTotal) || 0) : offerCents;
      const items = Array.from(box.querySelectorAll('[data-rgv2-gift]'));
      let reached = 0;
      items.forEach((item) => {
        if (item.hasAttribute('data-unavailable')) { item.setAttribute('data-reached', 'false'); return; }
        const ok = totalCents >= Number(item.dataset.amount);
        item.setAttribute('data-reached', ok ? 'true' : 'false');
        if (ok) reached += 1;
      });
      const max = Number(box.dataset.max) || 0;
      const bar = box.querySelector('[data-rgv2-gifts-progress]');
      if (bar && max) bar.style.width = Math.min(100, Math.floor((totalCents / max) * 100)) + '%';
      const count = box.querySelector('[data-rgv2-gifts-count]');
      if (count) count.textContent = reached + '/' + items.length + ' ' + (reached > 1 ? 'débloqués' : 'débloqué');
    });
  }
  let rgv2GiftsTimer = null;
  function rgv2RefreshGiftsFromCart() {
    if (rgv2GiftsTimer) window.clearTimeout(rgv2GiftsTimer);
    rgv2GiftsTimer = window.setTimeout(() => {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((c) => { if (c && typeof c.total_price === 'number') applyGiftsCartTotal(c.total_price); })
        .catch(() => {});
    }, 900);
  }
  function initGiftsCartSync() {
    const box = document.querySelector('[data-rgv2-gifts]');
    if (!box) return;
    applyGiftsCartTotal(Number(box.dataset.cartTotal) || 0);
    /* Dawn publie cartUpdate via son pub/sub quand il est présent. */
    try { if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, rgv2RefreshGiftsFromCart); } } catch (e) {}
    /* Filets : après tout envoi d'un formulaire d'ajout, et à l'ouverture du panier. */
    document.addEventListener('submit', (e) => { const f = e.target; if (f && f.action && String(f.action).indexOf('/cart/add') !== -1) rgv2RefreshGiftsFromCart(); }, true);
    document.addEventListener('click', (e) => { const a = e.target && e.target.closest ? e.target.closest('a[href="/cart"], .header__icon--cart, [data-rgv2-sticky] button') : null; if (a) rgv2RefreshGiftsFromCart(); }, true);
  }
  document.addEventListener('DOMContentLoaded', initGiftsCartSync);

  function initCountdown(scope) {
    scope.querySelectorAll('[data-rgv2-demand]').forEach((box) => {
      if (box.dataset.rgv2Init === 'true') return;
      box.dataset.rgv2Init = 'true';
      const raw = box.dataset.deadline;
      const timer = box.querySelector('[data-rgv2-countdown]');
      const value = box.querySelector('[data-rgv2-countdown-value]');
      if (!timer || !value) return;
      const demoMin = parseInt(box.dataset.demoMinutes || '0', 10);
      if (!raw && demoMin > 0) {
        /* Compte à rebours PAR VISITE (décision Kyrian 01/10) : démarre à N minutes à
           l'arrivée, mémorisé dans la session du navigateur (un rechargement ne le
           remet pas à N), figé à 00:00 à la fin. */
        const pad2 = (n) => String(n).padStart(2, '0');
        const key = 'rgv2-demand-end-' + demoMin;
        let demoEnd = 0;
        try { demoEnd = parseInt(window.sessionStorage.getItem(key) || '0', 10); } catch (e) { demoEnd = 0; }
        if (!demoEnd || demoEnd > Date.now() + demoMin * 60000) {
          demoEnd = Date.now() + demoMin * 60000;
          try { window.sessionStorage.setItem(key, String(demoEnd)); } catch (e) { /* stockage indisponible */ }
        }
        const demoTick = () => {
          const left = Math.max(0, demoEnd - Date.now());
          const m = Math.floor(left / 60000);
          const sec = Math.floor((left % 60000) / 1000);
          value.textContent = pad2(m) + ':' + pad2(sec);
          if (left <= 0) window.clearInterval(box._rgv2Timer);
        };
        demoTick();
        timer.hidden = false;
        box._rgv2Timer = window.setInterval(demoTick, 1000);
        return;
      }
      if (!raw) return;
      const end = new Date(raw).getTime();
      if (isNaN(end)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) { box.hidden = true; window.clearInterval(box._rgv2Timer); return; }
        /* Affichage HH:MM:SS sans les jours (demande Kyrian 01/10) : les heures
           cumulent les jours restants (ex. 729:47:31), jamais un faux « 09:47 ». */
        const h = Math.floor(left / 3600000);
        const m = Math.floor((left % 3600000) / 60000);
        const sec = Math.floor((left % 60000) / 1000);
        value.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
      };
      tick();
      timer.hidden = false;
      box._rgv2Timer = window.setInterval(tick, 1000);
    });
  }

  /* Carrousels avec commandes explicites (résultats, ingrédients — mobile) :
     flèches, compteur « 1 / 3 », une carte par déplacement, pas d'avance automatique. */
  function initCarousels(scope) {
    scope.querySelectorAll('[data-rgv2-carousel]').forEach((box) => {
      if (box.dataset.rgv2Init === 'true') return;
      box.dataset.rgv2Init = 'true';
      const track = box.querySelector('[data-rgv2-carousel-track]');
      if (!track) return;
      const items = () => Array.from(track.children).filter((el) => el.offsetWidth > 0);
      const prev = box.querySelector('[data-rgv2-car-prev]');
      const next = box.querySelector('[data-rgv2-car-next]');
      const count = box.querySelector('[data-rgv2-car-count]');
      const idx = () => {
        const it = items(); if (!it.length) return 0;
        const x = track.scrollLeft; let best = 0, bd = Infinity;
        it.forEach((el, k) => { const d = Math.abs(el.offsetLeft - track.offsetLeft - x); if (d < bd) { bd = d; best = k; } });
        return best;
      };
      const update = () => {
        const it = items(); const i = idx();
        if (count) count.textContent = (i + 1) + ' / ' + it.length;
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= it.length - 1;
      };
      const go = (d) => {
        const it = items(); const i = Math.max(0, Math.min(it.length - 1, idx() + d));
        track.scrollTo({ left: it[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', () => go(-1));
      if (next) next.addEventListener('click', () => go(1));
      let t2;
      track.addEventListener('scroll', () => { window.clearTimeout(t2); t2 = window.setTimeout(update, 90); }, { passive: true });
      window.addEventListener('resize', () => { window.clearTimeout(t2); t2 = window.setTimeout(update, 150); }, { passive: true });
      update();
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-rgv2-main]').forEach(initSticky);
    initCarousels(scope);
    initBeforeAfter(scope);
    initReviewLinks(scope);
    initOfferLinks(scope);
    initCountdown(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  // Theme Editor : re-initialisation quand une section est rechargée
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
